import { render } from "./WalletAddress.vue?vue&type=template&id=2747341e&scoped=true"
import script from "./WalletAddress.vue?vue&type=script&lang=js"
export * from "./WalletAddress.vue?vue&type=script&lang=js"

import "./WalletAddress.vue?vue&type=style&index=0&id=2747341e&lang=scss&scoped=true"

import exportComponent from "H:\\git\\Net_Web_LandingVue\\vue-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2747341e"]])

export default __exports__